const UPDATE_USER_BY_ID = `
  mutation UpdateUserById(
    $id: uuid!,
    $email: String!,
    $firstName: String!,
    $lastName: String!
    $phone: String!,
  ) {
    update_users_by_pk(pk_columns: {id: $id}, _set: {
      email: $email,
      first_name: $firstName,
      last_name: $lastName,
      phone_number: $phone,
    }) {
      email
      first_name
      last_name
      phone_number
      title
    }
  }
`

export default UPDATE_USER_BY_ID
